import { render } from "./Alert2Icon.vue?vue&type=template&id=cc7413c6&scoped=true"
const script = {}

import "./Alert2Icon.vue?vue&type=style&index=0&id=cc7413c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc7413c6"]])

export default __exports__